<template>
  <v-expansion-panel
    v-model="isOpen"
    class="elevation-0 filter-panel"
    expand
    flat
    expand-icon=""
  >
    <v-expansion-panel-content style="background-color: transparent">
      <template
        v-slot:header
        class="pa-0"
      >
        <span>
          <v-btn
            class="ma-0 filter-button"
            color="grey darken-1"
          >
            <v-icon class="mr-2">tune</v-icon> Filter
          </v-btn>
        </span>
      </template>
      <v-card style="background-color: transparent">
        <v-card-text
          style="background-color: transparent"
          class="px-0 pt-0"
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              md7
            >
              <v-text-field
                v-model="keyword"
                label="Keyword Search"
                prepend-inner-icon="search"
                hide-details
                clearable
              />
            </v-flex>
            <v-flex
              xs12
              md7
            >
              <GroupsDropDown
                :clearable="true"
                :is-my-groups="true"
                :init-groups="groups"
                @select-item="selectedGroups"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <small class="grey--text">Filters are applied to both "My Tasks" and "Task Pool"</small>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style >
  .filter-panel .v-expansion-panel__header {
    padding: 0;
  }
  .filter-panel .v-expansion-panel__header__icon{
    display: none;
  }
  .filter-panel .filter-button {
    left: -18px
  }
</style>
<script>
  import { isString } from 'lodash'
  import GroupsDropDown from '@/components/Common/GroupsDropDown'


  export default {
    components: {
      GroupsDropDown
    },
    data() {
      return {
        panel: false
      }
    },
    computed: {
      isOpen: {
        get() {
          return this.$store.state.tasks.filters.isOpen
            ? [ true ]
            : [ false ]
        },
        set(val) {
          const isOpen = Array.isArray(val) ? !!val[0] : false
          this.$store.commit('patchTaskFilter', { isOpen })
        }
      },
      keyword: {
        get() {
          return this.$store.state.tasks.filters.keyword
        },
        set(val) {
          const keyword = isString(val) ? val.trim() : ''
          this.$store.commit('patchTaskFilter', { keyword })
        }
      },
      groups: {
        get() {
          return this.$store.state.tasks.filters.groups
        },
        set(groups) {
          this.$store.commit('patchTaskFilter', { groups })
        }
      }
    },
    methods: {
      selectedGroups(selectedGroups) {
        this.groups = selectedGroups
      }
    }
  }
</script>

